import type { AxiosRequestConfig } from 'axios'

export const baseAxiosConfig = Object.freeze({
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30_000,
} as const) satisfies AxiosRequestConfig
